import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleCard = ({ role, permissions, onSelect, isSelected }) => {
  const getRoleIcon = (roleName) => {
    switch (roleName) {
      case 'admin':
        return 'Shield';
      case 'analyst':
        return 'BarChart';
      case 'merchant':
        return 'Store';
      default:
        return 'User';
    }
  };

  const getRoleColor = (roleName) => {
    switch (roleName) {
      case 'admin':
        return 'text-error bg-error/10 border-error/20';
      case 'analyst':
        return 'text-primary bg-primary/10 border-primary/20';
      case 'merchant':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const countActivePermissions = () => {
    if (!permissions || permissions?.length === 0) return 0;
    return permissions?.reduce((count, perm) => {
      const activePerms = [
        perm?.canView,
        perm?.canEdit,
        perm?.canCreate,
        perm?.canDelete,
        perm?.canExport
      ]?.filter(Boolean)?.length;
      return count + activePerms;
    }, 0);
  };

  const activePermissionsCount = countActivePermissions();
  const totalPossiblePermissions = (permissions?.length || 0) * 5;

  return (
    <button
      onClick={onSelect}
      className={`w-full text-left bg-white rounded-lg border-2 p-6 transition-all hover:shadow-md ${
        isSelected ? 'border-primary shadow-md' : 'border-border'
      }`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg ${getRoleColor(role)}`}>
          <Icon name={getRoleIcon(role)} size={24} />
        </div>
        {isSelected && (
          <div className="bg-primary text-primary-foreground px-2 py-1 rounded text-xs font-medium">
            Selected
          </div>
        )}
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2 capitalize">{role}</h3>
      <p className="text-sm text-muted-foreground mb-4">
        {activePermissionsCount} of {totalPossiblePermissions} permissions active
      </p>
      <div className="w-full bg-muted rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all"
          style={{ width: `${(activePermissionsCount / totalPossiblePermissions) * 100}%` }}
        />
      </div>
    </button>
  );
};

export default RoleCard;